import gql from 'graphql-tag';

export const GET_PUBLICATION = gql`
  query ($id: ID!) {
    publication(id: $id) {
      publicationType
      publicationAuthors
      publicationTitle
      publicationName
      applicantRole
      specificRole
      publicationStatus
      publicationDate
      issuePageArticelNo
      peerReviewedIndicator
      citationInfo
      publicationUrl
      supportingDocuments {
        id
        link
        name
      }
    }
  }
`;
